module.exports = __webpack_public_path__ + "static/media/MALE.d8a5e7a2.png";